(function () {
  var GAP_STACKED = 16;
  var GAP_TABLET_UP_MIN_W = 768;
  var GAP_FALLBACK = 43;
  var MAX_LIFT = 160;
  var PRE_ENGAGE_PX = 240;
  var RELEASE_PX = 120;
  var DEADBAND_PX = 4;
  var MIN_CLEAR_PX = 6;
  var BAR_GAP_MIN = 12;

  var root = document.documentElement;
  var chat = null, strip = null, footer = null, bar = null;
  var naturalBottomInset = null, naturalEndInset = null;
  var parked = false, parkedLift = 0;
  var barLift = 0, barEngaged = false, barEndShift = 0, barLastLift = 0;
  var written = null, writtenEnd = null;
  var frame = 0, glideFrame = 0;

  function activator() {

    if (!chat || !chat.shadowRoot) return null;
    var a = chat.shadowRoot.querySelector('button.activator');
    if (a) return a;
    var rt = chat.shadowRoot.querySelector('shopify-agent-runtime');
    return rt && rt.shadowRoot ? rt.shadowRoot.querySelector('button.activator, [part~="activator"]') : null;
  }

  function restingBox(act) {
    var a = act.getBoundingClientRect();
    if (!a.height) return null;
    var tx = 0, ty = 0;
    var t = window.getComputedStyle(act).translate;
    if (t && t !== 'none') { var p = t.split(' '); tx = parseFloat(p[0]) || 0; ty = parseFloat(p[1]) || 0; }
    var hostBottom = chat ? parseFloat(window.getComputedStyle(chat).bottom) || 0 : 0;
    return { bottom: a.bottom - ty + hostBottom, right: a.right - tx, left: a.left - tx, top: a.top - ty + hostBottom, height: a.height };
  }

  function gapFor() {
    if (window.innerWidth < GAP_TABLET_UP_MIN_W) return GAP_STACKED;
    if (!footer || !strip) return GAP_FALLBACK;
    var below = footer.getBoundingClientRect().bottom - strip.getBoundingClientRect().bottom;
    return below > 0 && below < 200 ? below : GAP_FALLBACK;
  }

  function gapForBar(barRect) {
    var own = window.innerHeight - barRect.bottom;
    if (!(own > 0) || own > 80) return BAR_GAP_MIN;
    return Math.max(BAR_GAP_MIN, Math.round(own));
  }

  function computeBarLift() {
    barLift = 0;
    if (!bar) { barEngaged = false; return; }
    var cs = window.getComputedStyle(bar);
    var shown = cs.display !== 'none' &&
      !bar.classList.contains('sticky-atc--out') &&
      !bar.classList.contains('sticky-atc--minimized') &&
      !document.body.classList.contains('scrolled-to-bottom');
    if (!shown) {

      if (barEngaged && barLastLift > 0 && document.body.classList.contains('scrolled-to-bottom')) {
        barLift = barLastLift;
        return;
      }
      barEngaged = false; barLastLift = 0; return;
    }
    var act = activator();
    if (!act || naturalBottomInset === null) { barEngaged = false; return; }
    var a = restingBox(act);
    var live = bar.getBoundingClientRect();
    if (!a || !live.height) { barEngaged = false; return; }
    var ty = 0;
    try { ty += new DOMMatrixReadOnly(cs.transform === 'none' ? undefined : cs.transform).m42; } catch (e) {}
    if (cs.translate && cs.translate !== 'none') { var parts = cs.translate.split(' '); if (parts[1]) ty += parseFloat(parts[1]) || 0; }
    var b = { top: live.top - ty, bottom: live.bottom - ty, left: live.left, right: live.right };
    naturalEndInset = window.innerWidth - a.right;
    if (b.right + BAR_GAP_MIN <= a.left || a.right + BAR_GAP_MIN <= b.left) { barEngaged = false; return; }
    var need = (window.innerHeight - naturalBottomInset) - (b.top - gapForBar(b));
    if (need <= 0) { barEngaged = false; return; }
    barLift = Math.min(Math.round(need), MAX_LIFT);
    barLastLift = barLift;
    var barEndInset = window.innerWidth - b.right;
    barEndShift = (naturalEndInset !== null && barEndInset > 0) ? Math.max(0, barEndInset - naturalEndInset) : 0;
    barEngaged = true;
  }

  var roomKey = '', roomAbove = Infinity;
  function measureRoomAbove(s, act) {
    var key = root.scrollHeight + 'x' + window.innerWidth + 'x' + window.innerHeight;
    if (key === roomKey) return roomAbove;
    roomKey = key; roomAbove = Infinity;
    var a = restingBox(act);
    if (!a || !footer) return roomAbove;
    var els = footer.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (strip.contains(el) || el.contains(strip)) continue;

      if (el.children.length && !/^(A|BUTTON|SELECT|INPUT|IMG|svg)$/.test(el.tagName)) continue;
      var r = el.getBoundingClientRect();
      if (!r.height || !r.width || r.bottom > s.top + 1) continue;
      if (r.right <= a.left || r.left >= a.right) continue;
      roomAbove = Math.min(roomAbove, s.top - r.bottom);
    }
    return roomAbove;
  }

  function computePark() {
    if (!strip || naturalBottomInset === null) { parked = false; return; }
    var s = strip.getBoundingClientRect();
    if (!s.height) { parked = false; return; }
    var fromEnd = root.scrollHeight - (s.top + window.scrollY);
    var stripTopAtEnd = window.innerHeight - fromEnd;
    var restingBottom = window.innerHeight - naturalBottomInset;
    var gap = gapFor();
    var act = activator();
    if (act) {

      var slot = measureRoomAbove(s, act) - (act.getBoundingClientRect().height || 50);
      if (slot - gap < MIN_CLEAR_PX) gap = Math.max(MIN_CLEAR_PX, Math.floor(slot / 2));
    }
    parkedLift = Math.max(0, Math.min(Math.round(restingBottom - (stripTopAtEnd - gap)), MAX_LIFT));
    var engageAt = window.innerHeight + PRE_ENGAGE_PX;

    var hidden = !root.classList.contains('sp-chat-ready');
    if (!parked && s.top < engageAt + (hidden ? RELEASE_PX : 0)) parked = true;
    else if (parked && s.top > engageAt + RELEASE_PX) parked = false;
  }

  function writeLift() {
    var host = chat || root;
    var want = Math.max(parked ? parkedLift : 0, barEngaged ? barLift : 0);
    want = Math.max(0, Math.min(Math.round(want), MAX_LIFT));
    var end = barEngaged ? Math.max(0, Math.round(barEndShift)) : 0;

    if (written !== null && want > 0 && written > 0 && Math.abs(want - written) <= DEADBAND_PX && end === writtenEnd) return;
    if (want === written && end === writtenEnd) return;

    var instant = !root.classList.contains('sp-chat-ready');
    if (instant) host.style.setProperty('--sp-chat-glide', '0s');
    host.style.setProperty('--sp-chat-lift', want + 'px');
    host.style.setProperty('--sp-chat-inset-end', end + 'px');
    written = want; writtenEnd = end;
    if (instant) {
      void (activator() || host).getBoundingClientRect();

      if (glideFrame) cancelAnimationFrame(glideFrame);
      glideFrame = requestAnimationFrame(function () { glideFrame = 0; host.style.removeProperty('--sp-chat-glide'); });
    }
  }

  function update() {
    frame = 0;
    if (!chat) return;
    var act = activator();
    if (act) { var a = restingBox(act); if (a) naturalBottomInset = window.innerHeight - a.bottom; }
    computeBarLift();
    computePark();
    writeLift();
  }

  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(update);
  }

  function observeActivator(ro) {
    var tries = 0;
    var timer = setInterval(function () {
      var a = activator();
      if (a) { if (ro) ro.observe(a); clearInterval(timer); schedule(); }
      else if (++tries > 150) clearInterval(timer);
    }, 60);
  }

  function start() {
    strip = document.querySelector('.sp-footer__legal');
    bar = document.querySelector('.sticky-atc');
    footer = strip ? (strip.closest('.sp-footer, .section-sp-footer, footer') || strip.parentElement) : null;
    if (bar) {

      new MutationObserver(schedule).observe(bar, { attributes: true, attributeFilter: ['class'] });
      bar.addEventListener('transitionend', schedule);
      new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('load', schedule);

    new MutationObserver(schedule).observe(root, { attributes: true, attributeFilter: ['class'] });
    var ro = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    if (ro) { ro.observe(document.body); if (footer) ro.observe(footer); }
    observeActivator(ro);
    schedule();
  }

  function findChat() {
    chat = document.querySelector('shopify-chat');
    if (!chat) return false;
    root.style.removeProperty('--sp-chat-lift');
    root.style.removeProperty('--sp-chat-inset-end');
    start();
    return true;
  }

  if (!findChat()) {
    var mo = new MutationObserver(function () { if (findChat()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
})();
